import React, { useState } from 'react';
import useStore from '../store/store';
import SoundPowerDB from './panels/SoundPowerDB';
import SoundPowerOctaves from './panels/SoundPowerOctaves';
import MeasuredDbPanel from './panels/MeasureDbPanel';
import MeasuredOctaves from './panels/MeasuredOctaves'
import { Container, Row, Col } from 'react-grid-system';
import RightPanel from './panels/RightPanel';
import Detail from './Detail';

const Multiband = ({
	sourceHeight,
	receiverHeight,
	distance,
	PathDifference,
	distanceAttenuation,
	barrierHeight,
	barrierXpos,
	BarrierToRecieverDistance,
	sourceSoundPower,
	calcsB2,
	frequency,
	RecieverNoiseLevel2,
	RecieverNoiseLevel,
	receiverSPLNoBarrier
}) => {
	/* A comment */
	const [displaySingleFrequency, setDisplaySingleFrequency] = useState(true);
	const setinitialMeasurementDistance = useStore((state) => state.setinitialMeasurementDistance);
	const setinitialSoundNoise = useStore((state) => state.setinitialSoundNoise);
	const setinitialSourceSoundPower = useStore((state) => state.setinitialSourceSoundPower);
	const setinitialFrequency = useStore((state) => state.setinitialFrequency);
	const initialMeasurementDistance = useStore((state) => state.initialMeasurementDistance);
	const initialSoundNoise = useStore((state) => state.initialSoundNoise);
	const initialSourceSoundPower = useStore((state) => state.initialSourceSoundPower);
	const initialFrequency = useStore((state) => state.frequency);
	const setScenario = useStore((state) => state.setScenario);
	const activePanel = useStore((state) => state.activeDBorOctavePanel);

	distance =  useStore((state) => state.distance);
	

	const [bandSets, setBandSets] = useState(
		{
			b63: 100,
			b125: 100,
			b250: 100,
			b500: 100,
			b1000: 100,
			b2000: 100,
			b4000: 100,
			b8000: 100
			//b16000: 100,
		});
	const [bandSetNoise, setBandSetNoise] = useState(
		{
			
			b63sn: 100,
			b125sn: 100,
			b250sn: 100,
			b500sn: 100,
			b1000sn: 100,
			b2000sn: 100,
			b4000sn: 100,
			b8000sn: 100,
		}
	)

	const resetOctavesValues = () => {
		setBandSets({
			b63: 100,
			b125: 100,
			b250: 100,
			b500: 100,
			b1000: 100,
			b2000: 100,
			b4000: 100,
			b8000: 100
		})

		setBandSetNoise({
			// b63sn: 100 - 26.2,
			// b125sn: 100 - 16.1,
			// b250sn: 100 - 8.6,
			// b500sn: 100 - 3.2,
			// b1000sn: 100,
			// b2000sn: 100 + 1.2,
			// b4000sn: 100 + 1,
			// b8000sn: 100 - 1.1,
			b63sn: 100,
			b125sn: 100,
			b250sn: 100,
			b500sn: 100,
			b1000sn: 100,
			b2000sn: 100,
			b4000sn: 100,
			b8000sn: 100,
		})
		
	}

	const { b63, b125, b250, b500, b1000, b2000, b4000, b8000 } = bandSets;
	const { b63sn, b125sn, b250sn, b500sn, b1000sn, b2000sn, b4000sn, b8000sn } = bandSetNoise;

	let b63dba = b63 - 26.2;
	let b125dba = b125 - 16.1;
	let b250dba = b250 - 8.6;
	let b500dba = b500 - 3.2;
	let b1000dba = b1000;
	let b2000dba = b2000 + 1.2;
	let b4000dba = b4000 + 1;
	let b8000dba = b8000 - 1.1;
	
	if(activePanel === 'soundPowerOCTAVES')
	{
		b63dba = parseInt(b63sn) - 26.2;
		b125dba = parseInt(b125sn) - 16.1;
		b250dba = parseInt(b250sn) - 8.6;
		b500dba = parseInt(b500sn) - 3.2;
		b1000dba = parseInt(b1000sn);
		b2000dba = parseInt(b2000sn) + 1.2;
		b4000dba = parseInt(b4000sn) + 1;
		b8000dba = parseInt(b8000sn) - 1.1;
		//console.log(b63dba, b125dba, b250dba, b500dba, b1000dba, b2000dba, b4000dba, b8000dba);
	}
	//const { b63dba, b125dba, b250dba, b500dba, b1000dba, b2000dba, b4000dba, b8000dba } = bandSetNoiseDba;


	let totalSourceNoise = Math.log10(
		Math.pow(10, (b63 / 10))
		+ Math.pow(10, (b125 / 10))
		+ Math.pow(10, (b250 / 10))
		+ Math.pow(10, (b500 / 10))
		+ Math.pow(10, (b1000 / 10))
		+ Math.pow(10, (b2000 / 10))
		+ Math.pow(10, (b4000 / 10))
		+ Math.pow(10, (b8000 / 10))
		//+Math.pow(10,(b16000/10))
	) * 10;

	let totalSourceNoiseDba = Math.log10(
		Math.pow(10, (b63dba / 10))
		+ Math.pow(10, (b125dba / 10))
		+ Math.pow(10, (b250dba / 10))
		+ Math.pow(10, (b500dba / 10))
		+ Math.pow(10, (b1000dba / 10))
		+ Math.pow(10, (b2000dba / 10))
		+ Math.pow(10, (b4000dba / 10))
		+ Math.pow(10, (b8000dba / 10))
		//+Math.pow(10,(b16000/10))
	) * 10;


	let totalSourceNoiseA = Math.log10(
		Math.pow(10, (b63sn / 10))
		+ Math.pow(10, (b125sn / 10))
		+ Math.pow(10, (b250sn / 10))
		+ Math.pow(10, (b500sn / 10))
		+ Math.pow(10, (b1000sn / 10))
		+ Math.pow(10, (b2000sn / 10))
		+ Math.pow(10, (b4000sn / 10))
		+ Math.pow(10, (b8000sn / 10))
	) * 10;

	const GetCalcsB2 = (band) => {
		const calcsB2a = 2 * PathDifference;
		const calcsB2b = (band / 343);
		const calcsB2c = calcsB2a * calcsB2b;
		let calcsB2result = ((sourceSoundPower == null) ? sourceSoundPower : Math.log10(calcsB2c));
		return calcsB2result;
	}

	distanceAttenuation = 20 * Math.log10(distance);

	let measuredDistance = initialMeasurementDistance;

	let distanceAttenuationMeasured = 20 * Math.log10(distance / measuredDistance);

	const calculateBarrierAttenuation = (band, input) => {
		calcsB2 = GetCalcsB2(band);
		let result = (
			((receiverHeight - sourceHeight) / (barrierXpos + BarrierToRecieverDistance)) > ((barrierHeight - sourceHeight) / barrierXpos)
				? 0
				:
				(PathDifference === 0
					?
					5
					:
					(
						(input == null || input == 0)
							?
							input
							:
							13.33 + 8.34
							* calcsB2 + 2.445
							* Math.pow(calcsB2, 2) - 0.8838
							* Math.pow(calcsB2, 3) - 0.3012
							* Math.pow(calcsB2, 4) + 0.1644
							* Math.pow(calcsB2, 5) + 0.01832
							* Math.pow(calcsB2, 6) - 0.010024
							* Math.pow(calcsB2, 7)
					)
				)
		)
		return result;
	}

	const calculateRecieverNoiseLin = (bandNoise, bandBarrierAtn, bandDistanceAtn) => {
		return (bandNoise - bandBarrierAtn - bandDistanceAtn);
	}

	const calculateRecieverNoiseA = (bandSourceNoise, bandBarrierAtn, bandDistanceAtn) => {
		//console.log(bandSourceNoise, bandBarrierAtn, bandDistanceAtn);
		return (bandSourceNoise - bandBarrierAtn - bandDistanceAtn);
	}

	const calculateRecieverNoiseDba = (bandSourceNoise) => {
		
		let res = bandSourceNoise-(20*Math.log10(distance))-8

		return (res);
	}

	const roundValue = (value) => {
		return +(Math.round(value + "e+1") + "e-1");
	}

	const calculateRecieverNoiseWithoutBarriersMeasured = (noiseBand, ba) => {
		//let distanceAttenuation1 = 20 * Math.log(distance/measuredDistance);
		//let distanceAttenuation1 = 20 * Math.log(distance);
		//console.log(distanceAttenuation1, noiseBand);
		//let resm = noiseBand - (distanceAttenuation1);
		let resm = noiseBand - distanceAttenuationMeasured;
		return (resm);
	}

	const calculateRecieverNoiseWithoutBarrierSoundPower = (noiseBand) => {
		let res = noiseBand - distanceAttenuation;
		return (res);
	}

	const calculateRecieverSPLNoBarrier = (dblin) =>
	{
		//console.log("band is",dblin);
		
		let res = dblin-(20*Math.log10(distance))-8;
		return res;
	}
	//distanceAttenuation same for all; maybe not for A! 
	//ba = barrier attenuation (universal)
	//rnlin = measured received noise with barrier
	//nvnb = measured noise no barrier
	//spnnb = sound power noise no barrier
	//nrla = sound power noise with barrier
	//splnb = spl no barrier calculation.

	let b63ba = calculateBarrierAttenuation(63, b63);
	let b63rnlin = calculateRecieverNoiseLin(b63, b63ba, distanceAttenuationMeasured);
	let b63nvnb = calculateRecieverNoiseWithoutBarriersMeasured(b63,b63ba, distanceAttenuation);
	let b63nrla = calculateRecieverNoiseA(b63sn, b63ba, distanceAttenuation);
	let b63spnnb = calculateRecieverNoiseWithoutBarrierSoundPower(b63sn, distanceAttenuation);
	let b63splnb = calculateRecieverSPLNoBarrier(b63sn);
	let b63sp = b63splnb - b63ba;
	let b63spdba = calculateRecieverNoiseDba(b63dba);
	let b63badba = b63spdba - b63ba;
	b63nvnb = calculateRecieverNoiseWithoutBarriersMeasured(b63dba);
	b63rnlin = b63nvnb - b63ba;

	let b125ba = calculateBarrierAttenuation(125, b125);
	let b125rnlin = calculateRecieverNoiseLin(b125, b125ba, distanceAttenuationMeasured);
	let b125nvnb = calculateRecieverNoiseWithoutBarriersMeasured(b125, distanceAttenuationMeasured);
	let b125nrla = calculateRecieverNoiseA(b125, b125ba, distanceAttenuation);
	let b125spnnb = calculateRecieverNoiseWithoutBarrierSoundPower(b125sn, distanceAttenuation);
	let b125splnb = calculateRecieverSPLNoBarrier(b125sn);
	let b125sp = b125splnb - b125ba;
	let b125spdba = calculateRecieverNoiseDba(b125dba);
	let b125badba = b125spdba - b125ba;
	b125nvnb = calculateRecieverNoiseWithoutBarriersMeasured(b125dba);
	b125rnlin = b125nvnb - b125ba;

	let b250ba = calculateBarrierAttenuation(250, b250);
	let b250rnlin = calculateRecieverNoiseLin(b250, b250ba, distanceAttenuationMeasured);
	let b250nvnb = calculateRecieverNoiseWithoutBarriersMeasured(b250, distanceAttenuationMeasured);
	let b250nrla = calculateRecieverNoiseA(b250, b250ba, distanceAttenuation);
	let b250spnnb = calculateRecieverNoiseWithoutBarrierSoundPower(b250sn, distanceAttenuation);
	let b250splnb = calculateRecieverSPLNoBarrier(b250sn);
	let b250sp = b250splnb - b250ba;
	let b250spdba = calculateRecieverNoiseDba(b250dba);
	let b250badba = b250spdba - b250ba;
	b250nvnb = calculateRecieverNoiseWithoutBarriersMeasured(b250dba);
	b250rnlin = b250nvnb - b250ba;

	let b500ba = calculateBarrierAttenuation(500, b500);
	let b500rnlin = calculateRecieverNoiseLin(b500, b500ba, distanceAttenuationMeasured);
	let b500nvnb = calculateRecieverNoiseWithoutBarriersMeasured(b500, distanceAttenuationMeasured);
	let b500nrla = calculateRecieverNoiseA(b500, b500ba, distanceAttenuation);
	let b500spnnb = calculateRecieverNoiseWithoutBarrierSoundPower(b500sn, distanceAttenuation);
	let b500splnb = calculateRecieverSPLNoBarrier(b500sn);
	let b500sp = b500splnb - b500ba;
	let b500spdba = calculateRecieverNoiseDba(b500dba);
	let b500badba = b500spdba - b500ba;
	b500nvnb = calculateRecieverNoiseWithoutBarriersMeasured(b500dba);
	b500rnlin = b500nvnb - b500ba;

	let b1000ba = calculateBarrierAttenuation(1000, b1000);
	let b1000rnlin = calculateRecieverNoiseLin(b1000, b1000ba, distanceAttenuationMeasured);
	let b1000nvnb = calculateRecieverNoiseWithoutBarriersMeasured(b1000, distanceAttenuationMeasured);
	let b1000spnnb = calculateRecieverNoiseWithoutBarrierSoundPower(b1000sn, distanceAttenuation);
	let b1000nrla = calculateRecieverNoiseA(b1000, b1000ba, distanceAttenuation);
	let b1000splnb = calculateRecieverSPLNoBarrier(b1000sn);
	let b1000sp = b1000splnb - b1000ba;
	let b1000spdba = calculateRecieverNoiseDba(b1000dba);
	let b1000badba = b1000spdba - b1000ba;
	b1000nvnb = calculateRecieverNoiseWithoutBarriersMeasured(b1000dba);
	b1000rnlin = b1000nvnb - b1000ba;

	let b2000ba = calculateBarrierAttenuation(2000, b2000);
	let b2000rnlin = calculateRecieverNoiseLin(b2000, b2000ba, distanceAttenuationMeasured);
	let b2000nvnb = calculateRecieverNoiseWithoutBarriersMeasured(b2000, distanceAttenuationMeasured);
	let b2000spnnb = calculateRecieverNoiseWithoutBarrierSoundPower(b2000sn, distanceAttenuation);
	let b2000nrla = calculateRecieverNoiseA(b2000, b2000ba, distanceAttenuation);
	let b2000splnb = calculateRecieverSPLNoBarrier(b2000sn);
	let b2000sp = b2000splnb - b2000ba;
	let b2000spdba = calculateRecieverNoiseDba(b2000dba);
	let b2000badba = b2000spdba - b2000ba;
	b2000nvnb = calculateRecieverNoiseWithoutBarriersMeasured(b2000dba);
	b2000rnlin = b2000nvnb - b2000ba;

	let b4000ba = calculateBarrierAttenuation(4000, b4000);
	let b4000rnlin = calculateRecieverNoiseLin(b4000, b4000ba, distanceAttenuationMeasured);
	let b4000nvnb = calculateRecieverNoiseWithoutBarriersMeasured(b4000, distanceAttenuationMeasured);
	let b4000spnnb = calculateRecieverNoiseWithoutBarrierSoundPower(b4000sn, distanceAttenuation);
	let b4000nrla = calculateRecieverNoiseA(b4000, b4000ba, distanceAttenuation);
	let b4000splnb = calculateRecieverSPLNoBarrier(b4000sn);
	let b4000sp = b4000splnb - b4000ba;
	let b4000spdba = calculateRecieverNoiseDba(b4000dba);
	let b4000badba = b4000spdba - b4000ba;
	b4000nvnb = calculateRecieverNoiseWithoutBarriersMeasured(b4000dba);
	b4000rnlin = b4000nvnb - b4000ba;

	let b8000ba = calculateBarrierAttenuation(8000, b8000);
	let b8000rnlin = calculateRecieverNoiseLin(b8000, b8000ba, distanceAttenuationMeasured);
	let b8000nvnb = calculateRecieverNoiseWithoutBarriersMeasured(b8000, distanceAttenuationMeasured);
	let b8000spnnb = calculateRecieverNoiseWithoutBarrierSoundPower(b8000sn, distanceAttenuation);
	let b8000nrla = calculateRecieverNoiseA(b8000, b8000ba, distanceAttenuation);
	let b8000splnb = calculateRecieverSPLNoBarrier(b8000sn);
	let b8000sp = b8000splnb - b8000ba;
	let b8000spdba = calculateRecieverNoiseDba(b8000dba);
	let b8000badba = b8000spdba - b8000ba;
	b8000nvnb = calculateRecieverNoiseWithoutBarriersMeasured(b8000dba);
	b8000rnlin = b8000nvnb - b8000ba;

	const receiverNoiseLevelBandsDba = [b63spdba,b125spdba,b250spdba,b500spdba,b1000spdba,b2000spdba,b4000spdba,b8000spdba]
	/* Used As WITH Barrier Reciever SPL In Sound Power */
	const receiverNoiseLevelSpDba = [b63badba,b125badba,b250badba,b500badba,b1000badba,b2000badba,b4000badba,b8000badba]

	const receiverNoiseLevelBands = [b63sp,b125sp,b250sp,b500sp,b1000sp,b2000sp,b4000sp,b8000sp]

	const measuredNoiseNoBarrier = [b63nvnb,b125nvnb,b250nvnb,b500nvnb,b1000nvnb,b2000nvnb,b4000nvnb,b8000nvnb]

	const receiverSPLList = [b63splnb,b125splnb,b250splnb,b500splnb,b1000splnb,b2000splnb,b4000splnb,b8000splnb]

	const measuredNoiseNoBarrierSoundPower = [b63spnnb,b125spnnb,b250spnnb,b500spnnb,b1000spnnb,b2000spnnb,b4000spnnb,b8000spnnb]

	let measuredNoiseNoBarrierTotal = Math.log10(Math.pow(10, (b63nvnb / 10))
		+ Math.pow(10, (b125nvnb / 10))
		+ Math.pow(10, (b250nvnb / 10))
		+ Math.pow(10, (b500nvnb / 10))
		+ Math.pow(10, (b1000nvnb / 10))
		+ Math.pow(10, (b2000nvnb / 10))
		+ Math.pow(10, (b4000nvnb / 10))
		+ Math.pow(10, (b8000nvnb / 10))) * 10;
	/*dB(A)*/
	let totalRecieverNoiseNoBarrierDba = Math.log10(Math.pow(10, (b63splnb / 10))
		+ Math.pow(10, (b125splnb / 10))
		+ Math.pow(10, (b250splnb / 10))
		+ Math.pow(10, (b500splnb / 10))
		+ Math.pow(10, (b1000splnb / 10))
		+ Math.pow(10, (b2000splnb / 10))
		+ Math.pow(10, (b4000splnb / 10))
		+ Math.pow(10, (b8000splnb / 10))) * 10;


	const barrierAttenuationList = [b63ba,b125ba,b250ba,b500ba,b1000ba,b2000ba,b4000ba,b8000ba]

	let valids = true;
	let barrierAttenuation = 1;
	let measurementDistance = 2;
	let sourceNoisePower = 3;

	let addRNLIN = Math.pow(10, (b63rnlin / 10))
		+ Math.pow(10, (b125rnlin / 10))
		+ Math.pow(10, (b250rnlin / 10))
		+ Math.pow(10, (b500rnlin / 10))
		+ Math.pow(10, (b1000rnlin / 10))
		+ Math.pow(10, (b2000rnlin / 10))
		+ Math.pow(10, (b4000rnlin / 10))
		+ Math.pow(10, (b8000rnlin / 10));


	let totalRecieverNoiceLin = Math.log10(addRNLIN) * 10;


	// let totalRecieverNoiseA = Math.log10(Math.pow(10, (b63nrla / 10))
	// 	+ Math.pow(10, (b125nrla / 10))
	// 	+ Math.pow(10, (b250nrla / 10))
	// 	+ Math.pow(10, (b500nrla / 10))
	// 	+ Math.pow(10, (b1000nrla / 10))
	// 	+ Math.pow(10, (b2000nrla / 10))
	// 	+ Math.pow(10, (b4000nrla / 10))
	// 	+ Math.pow(10, (b8000nrla / 10))) * 10;

	/* Linear */

	let totalRecieverNoiseA = Math.log10(Math.pow(10, (b63sp / 10))
	+ Math.pow(10, (b125sp / 10))
	+ Math.pow(10, (b250sp / 10))
	+ Math.pow(10, (b500sp / 10))
	+ Math.pow(10, (b1000sp / 10))
	+ Math.pow(10, (b2000sp / 10))
	+ Math.pow(10, (b4000sp / 10))
	+ Math.pow(10, (b8000sp / 10))) * 10;

	/*dB(A) */
	let receiverNoiseLevelSpDbaTotal = Math.log10(Math.pow(10, (b63badba / 10))
	+ Math.pow(10, (b125badba / 10))
	+ Math.pow(10, (b250badba / 10))
	+ Math.pow(10, (b500badba / 10))
	+ Math.pow(10, (b1000badba / 10))
	+ Math.pow(10, (b2000badba / 10))
	+ Math.pow(10, (b4000badba / 10))
	+ Math.pow(10, (b8000badba / 10))) * 10;

	const receiverNoiseLin = [b63rnlin,b125rnlin,b250rnlin,b500rnlin,b1000rnlin,b2000rnlin,b4000rnlin,b8000rnlin]
	const receiverNoiseA = [b63nrla,b125nrla,b250nrla,b500nrla,b1000nrla,b2000nrla,b4000nrla,b8000nrla]

	const soundPressureNoBarrier = initialSoundNoise - distanceAttenuationMeasured;

	function changeBandValue(e, item) {
		const value = e.target.value;
		setBandSets({ ...bandSets, [item]: value })
	}

	function changeBandNoiseValue(e, item) {
		const value = e.target.value;
		setBandSetNoise({ ...bandSetNoise, [item]: value })
		//setBandSets({ ...bandSets, [item]: value })
	}

	function onChange(e) {
		const value = e.target.value;
		setScenario(value);
	}

	const showCalculations = useStore((state) => state.showCalculations);
	const setShowCalculations = useStore((state) => state.setShowCalculations);
	

	const displayCalcsAndScroll = (showCalculations) => {
		if (showCalculations) {
			const myTimeout = setTimeout(scrollToCalcs, 200);
			function scrollToCalcs() {
				document.querySelector('#calculations').scrollIntoView({
					behavior: 'smooth'
				});
			}
		}
		setShowCalculations(showCalculations)
	};

	const showCalculationsButtonTitle = showCalculations ? 'Hide Calculations' : 'Show Calculations';
	return (
		<div className="content">
			<section className="section-margin-top">
				{
					activePanel === 'measuredDB' && (
						<Row style={{ justifyContent: 'center' }}>
							<Col xs={12} lg={9}>
								<MeasuredDbPanel
									RecieverNoiseLevel2={roundValue(RecieverNoiseLevel2)}
									initialMeasurementDistance={initialMeasurementDistance}
									setinitialMeasurementDistance={(e) => { setinitialMeasurementDistance(e) }}
									setinitialSoundNoise={setinitialSoundNoise}
									initialSoundNoise={initialSoundNoise}
									receiverSPLNoBarrier={soundPressureNoBarrier}
								/>
							</Col>
							<Col xs={12} sm={6} lg={3}>
								<div style={{ flexFlow: 'column' }}>
									<RightPanel resetOctavesValues={(e) => { resetOctavesValues(e) }} />
									<button onClick={(e) => displayCalcsAndScroll(!showCalculations)} className='action-button-inverted'>{showCalculationsButtonTitle}</button>
								</div>
							</Col>
						</Row>
					)
				}
				{
					activePanel === 'measuredOCTAVES' && (
						<Row style={{ justifyContent: 'center' }}>
							<Col xs={12} lg={9}>
								<MeasuredOctaves
									setinitialMeasurementDistance={(e) => { setinitialMeasurementDistance(e) }}
									bandSets={bandSets}
									changeBandValue={(e, item) => { changeBandValue(e, item) }}
									totalSourceNoise={totalSourceNoise}
									receiverNoiseLin={receiverNoiseLin}
									totalRecieverNoiceLin={totalRecieverNoiceLin}
									measuredNoiseNoBarrierTotal={measuredNoiseNoBarrierTotal}									
									measuredNoiseNoBarrier={measuredNoiseNoBarrier}
									totalSourceNoiseDba={totalSourceNoiseDba}
								/>
							</Col>
							<Col xs={12} sm={6} lg={3}>
								<div style={{ flexFlow: 'column' }}>
									<RightPanel resetOctavesValues={(e) => { resetOctavesValues(e) }} />
									<button onClick={(e) => displayCalcsAndScroll(!showCalculations)} className='action-button-inverted'>{showCalculationsButtonTitle}</button>
								</div>
							</Col>
						</Row>
					)
				}
				{

					activePanel === 'soundPowerOCTAVES' && (
						<Row style={{ justifyContent: 'center' }}>
							<Col xs={12} lg={9}>
								<SoundPowerOctaves
									changeBandNoiseValue={(e, item) => changeBandNoiseValue(e, item)}
									totalSourceNoiseA={totalSourceNoiseA}
									receiverNoiseA={receiverNoiseLevelSpDba}
									totalRecieverNoiseA={receiverNoiseLevelSpDbaTotal}
									bandSetNoise={bandSetNoise}
									measuredNoiseNoBarrierSoundPower={measuredNoiseNoBarrierSoundPower}
									measuredNoiseNoBarrierSoundPowerTotal={totalRecieverNoiseNoBarrierDba}
									barrierAttenuationList={barrierAttenuationList}
									receiverNoiseLin = {receiverNoiseLevelSpDba}
									receiverSPLList = {receiverNoiseLevelBandsDba}
									totalSourceNoiseDba={totalSourceNoiseDba}
								/>
							</Col>
							<Col xs={12} sm={6} lg={3}>
								<div style={{ flexFlow: 'column' }}>
									<RightPanel resetOctavesValues={(e) => { resetOctavesValues(e) }} />
									<button onClick={(e) => displayCalcsAndScroll(!showCalculations)} className='action-button-inverted'>{showCalculationsButtonTitle}</button>
								</div>
							</Col>
						</Row>
					)
				}
				{
					activePanel === 'soundPowerDB' && (
						<Row style={{ justifyContent: 'center' }}>
							<Col xs={12} lg={9}>
								<SoundPowerDB
									setinitialSourceSoundPower={(e) => { setinitialSourceSoundPower(e) }}
									initialSourceSoundPower={initialSourceSoundPower}
									setinitialFrequency={(e) => { setinitialFrequency(e) }}
									initialFrequency={initialFrequency}
									RecieverNoiseLevel={RecieverNoiseLevel}
									receiverSPLNoBarrier={receiverSPLNoBarrier}
								/>
							</Col>
							<Col xs={12} sm={6} lg={3}>
								<div style={{ flexFlow: 'column' }}>
									<RightPanel resetOctavesValues={(e) => { resetOctavesValues(e) }} />
									<button onClick={(e) => displayCalcsAndScroll(!showCalculations)} className='action-button-inverted'>{showCalculationsButtonTitle}</button>
								</div>
							</Col>
						</Row>
					)
				}

				<div>
					{showCalculations && (
						<Detail
							sourceHeight={sourceHeight}
							receiverHeight={receiverHeight}
							distance={distance}
							PathDifference={PathDifference}
							receiverSPLNoBarrier={receiverSPLNoBarrier}
							RecieverNoiseLevel={RecieverNoiseLevel}
							barrierAttenuation={barrierAttenuation}
							distanceAttenuation={distanceAttenuation}
							RecieverNoiseLevel2={RecieverNoiseLevel2}
							barrierHeight={barrierHeight}
							barrierXpos={barrierXpos}
							BarrierToRecieverDistance={BarrierToRecieverDistance}
							sourceSoundPower={sourceSoundPower}
							frequency={frequency}
							measurementDistance={initialMeasurementDistance}
							sourceNoisePower={initialSoundNoise}
							receiverSPLList = {receiverSPLList}
						/>
					)}
				</div>
			</section >
		</div>
	)
}

export default Multiband;
